import script from "./ColorPickerBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColorPickerBar.vue?vue&type=script&lang=ts&setup=true"

import "./ColorPickerBar.vue?vue&type=style&index=0&id=8906b0fe&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ColorPickerBar.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8906b0fe"]])

export default __exports__